import DeadlineDocket from '../../containers/ConnectMarketplaceDashboard/DeadlineDocket/DeadlineDocket';

export enum NotificationFlagsCategories {
    // Categories
    PracticesCode = 'PRACTICES',
    PmgCode = 'PMG',
    PocCode = 'POC',
    ReferralHubCode = 'RP',
    KnowledgeLibraryCode = 'KL',
    AccountCode = 'ACCOUNT',
    AnnouncementsCode = 'ANNOUNCEMENTS',
    OtherDataRequests = 'OTHER_DR',
    MpCode = 'MP',

    // Sub-categories
    FirstTimeVisitCode = 'FIRST_TIME_VISIT',
    CalendarCode = 'CALENDAR',
    ServicesPurchasingCode = 'SP',
    ClubBoardCode = 'CLUBBOARD',
    ClubRoomCode = 'CLUBROOM',
    VirtualMeetingCode = 'VM',
    ClipCode = 'SHARED.CLIP',
    ReferredPartiesCode = 'REFERRED_PARTIES',
    ReferralRewardsCode = 'REFERRAL_REWARDS',
    WalletCode = 'WALLET',
    RewardsHistoryCode = 'REWARDS_HISTORY',
    PurchaseHistoryCode = 'PURCHASE_HISTORY',
    RenewalDateCode = 'RENEWAL_DATE',
    EngagementCode = 'MY_ENGAGEMENT',
    EngagementStatusCode = 'ENGAGEMENT_STATUS',
    EngagementTimelinePreviewCode = 'TIMELINE_PREVIEW',
    CommsHubCode = 'COMMS_HUB',
    BrokerChatCode = 'BROKER_CHAT',
    BuyerCommsCode = 'BUYER_COMMS',
    GlobalCommsCode = 'GLOBAL_COMMS',
    MeetingCode = 'CONFIRMED_MEETING',
    MeetingProposalCode = 'MEETING_PROPOSAL',
    DataAndDocsCode = 'DATA_AND_DOCS',
    DataRequestsCode = 'DATA_REQUESTS',
    OpportunitiesCode = 'OPPORTUNITIES',
    OpportunityCode = 'OPPORTUNITY',
    OpportunityStatusCode = 'OPPORTUNITY_STATUS',
    EngagementDocumentsCode = 'ENGAGEMENT_DOCUMENTS',
    BuyersCode = 'BUYERS',
    BuyerStateCode = 'BUYER_STATE',
    BuyerStatusCode = 'BUYER_STATUS',
    BuyerSellerProfileCode = 'SELLER_PROFILE',
    DeadlineDocketCode = 'DEADLINE_DOCKET',
    MasterDeadlineDocketCode = 'MASTER_DEADLINE_DOCKET',
    EngagementHistoryCode = 'ENGAGEMENT_HISTORY',
    EngagementAutoPaymentCode = 'ENGAGEMENT_AUTO_PAYMENT',
    MeetingsCode = 'MEETINGS',
}
